export class Log {
  constructor(
    severity: string,
    userOid: string,
    onBehalfOfUserOid: string,
    method: string,
    message: string,
    groupeEtablissement: string,
    roles: string[]
  ) {
    this.severity = severity;
    this.userOid = userOid;
    this.onBehalfOfUserOid = onBehalfOfUserOid;
    this.method = method;
    this.message = message;
    this.groupeEtablissement = groupeEtablissement;
    this.roles = roles;
  }

  severity: string;
  userOid: string;
  onBehalfOfUserOid: string;
  method: string;
  message: string;
  groupeEtablissement: string;
  roles: string[];
}
